import { Card, Title3 } from '@fluentui/react-components';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { RevenuePoint } from '../../../hooks/useDashboard';

export const RevenueChart = ({ data }: { data: RevenuePoint[] }) => (
  <Card>
    <Title3>Revenue by month (USD)</Title3>
    <div style={{ width: '100%', height: 280 }}>
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip formatter={(value: number) => `$ ${value.toFixed(0)}`} />
          <Legend />
          <Bar dataKey="offers" name="Offers pipeline" fill="#0f6cbd" />
          <Bar dataKey="orders" name="Orders" fill="#107c10" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </Card>
);
